export const getCommonError = (error) => {
  const detailMessages = {
    1000: "비밀번호 변경에 실패했습니다. 다시 시도해주세요.",
    2000: "회원가입에 실패했습니다. 다시 시도해주세요.",
    3000: "로그인에 실패했습니다. 다시 시도해주세요.",
    4000: "아이디가 이미 사용 중입니다. 다른 아이디를 입력해주세요.",
    5000: "아이디가 존재하지 않습니다. 다른 아이디를 입력해주세요.",
    6000: "비밀번호가 잘못 입력되었습니다. 비밀번호를 5회 이상 잘못 입력하면 계정이 비활성화 됩니다.",
    6001: "비밀번호가 5회 이상 잘못 입력되어 계정이 비활성화 되었습니다. 계정 활성화는 관리자에게 문의하세요.",
    9000: "최근 5회 안에 사용한 비밀번호로 변경할 수 없습니다. 다른 비밀번호를 입력해주세요.",
  };

  const commonError = new Error(error.message);
  commonError.name = "CommonError";
  commonError.stack = error.stack;
  commonError.status = error.status;
  commonError.code = error.code;

  const { response } = error;
  if (response?.data) {
    const { code = "", message = "" } = response.data;
    if (code) {
      const dotIndex = code.indexOf(".");

      let detail = "";
      if (dotIndex !== -1) {
        const status = parseInt(code.split(".")[0]);
        detail = parseInt(code.split(".")[1]);

        const match = message.match(/\(-(\d+)\)/);
        if (match) {
          detail = parseInt(match[1]);
        }

        commonError.status = status;
        commonError.detail = detail;
        commonError.message = detailMessages[detail] || error.message;
      } else {
        const status = parseInt(code);

        const match = message.match(/\(-(\d+)\)/);
        if (match) {
          detail = parseInt(match[1]);
        }

        commonError.status = status;
        commonError.detail = detail;
        commonError.message = detailMessages[detail] || error.message;
      }
    }
  }

  return commonError;
};
